/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone} from '@angular/core';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import template from './cdn-upload-edit-page.component.html';

import {AdminResourceEditPageBase} from '../../common/controller/admin-resource-edit-page-base';
import type {FileUploadHandler} from '../../common/directives/file-upload/file-upload.util';
import type {FileUploadState} from '../../common/directives/file-upload/file-upload.component';
import {CdnAssetResource} from '../../../components/api/resources/resource/asset/cdn-asset.resource';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';

const UPLOAD_ACCEPT = '.webp,.jpg,.png,.jpeg,.gif,.zip,.swf,.html,.htm,.js,.txt,.json,.css,.xhtml,.xml,.woff,.eot,.svg,.ttf,.woff,.woff2,.htc,.mp4,.mp3,.webm,.vtt,.srt';

@Component({
  standalone: false,
  selector: 'adn-cdn-upload-edit-page',
  template
})
export class CdnUploadEditPageComponent extends AdminResourceEditPageBase {
  readonly uploadAccept = UPLOAD_ACCEPT;
  readonly cdnUploadWarningOptions = {mode: 'cdn-asset' as const};
  newUploadState: FileUploadState = {
    pristine: true,
    pending: false,
    invalid: false
  };

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(CdnAssetResource) private readonly CdnAsset: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
  }

  uploadCdnFile: FileUploadHandler = (file, onProgress) => {
    return this.CdnAsset.upload(this.editingModel.id, {file: file}, onProgress).then(
      (parentObject: any) => parentObject,
      (error: any) => Promise.reject(error)
    );
  };

  httpsPrefix(value: string): string {
    return value && value.indexOf('//') === 0 ? 'https:' + value : value;
  }

  onAssetUploaded(asset: any): void {
    this.saveDirect(asset);
  }

  onUploadStateChange(state: FileUploadState): void {
    this.newUploadState = state;
  }

  showsAssetDetails(): boolean {
    return !!(this.editingModel?.cdnId || this.editingModel?.fileName || this.editingModel?.mimeType);
  }

  isActionDisabled(editForm: any): boolean {
    if (!this.showsAssetDetails()) {
      return this.newUploadState.pristine
        || this.newUploadState.pending
        || (this.newUploadState.invalid && !this.hasValidationError);
    }
    return this.isSaveDisabled(editForm);
  }
}
